<ng-container *ngIf="deviceService.isMobileSmDown$ | async; else desktopButton">
  <button sdButton type="secondary" fullWidth="true" (click)="openModal()">
    <cx-icon type="POINT"></cx-icon>
    Поменять магазин
  </button>
</ng-container>
<ng-template #desktopButton>
  <button sdButton type="outlined" size="s" (click)="openModal()">Изменить</button>
</ng-template>
